import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { shortDigest, type Engagement } from '@ai-secure-twin/shared';
import { api } from '../../lib/api';

/**
 * This engagement's reports. Each is generated when the engagement is submitted for its Report
 * gate; a declined report stays listed, because the trail should show what was refused as well
 * as what was published.
 */
export function ReportsPanel({ engagement }: { engagement: Engagement }) {
  const reports = useQuery({
    queryKey: ['reports', engagement.id],
    queryFn: () => api.listReports(engagement.id),
  });
  const items = [...(reports.data?.items ?? [])].reverse();
  if (reports.isLoading || items.length === 0) return null;

  return (
    <section className="card panel" aria-labelledby="reports-title">
      <h2 id="reports-title" className="panel-title">
        Reports
      </h2>
      <div className="run-list">
        {items.map((r) => (
          <article key={r.version} className="run">
            <div className="run-head">
              <Link
                to={`/app/engagements/${engagement.id}/reports/${r.version}`}
                className="table-link"
              >
                Technical report v{r.version}
              </Link>
              <span className="mono muted" style={{ fontSize: 12 }}>
                sha256 {shortDigest(r.digest)}
              </span>
            </div>
            <p className="meta">
              Generated {new Date(r.generatedAt).toLocaleString()} · {r.findingCount} findings
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
